import React, { type PropsWithChildren } from "react";
import { type MatrixEvent } from "matrix-js-sdk/src/matrix";
import { Tooltip } from "@vector-im/compound-web";

// import { unicodeToShortcode } from "../../../HtmlUtils";
import { _t } from "../../../languageHandler";
import { formatList } from "../../../utils/FormattingUtils";
import MatrixClientContext from "../../../contexts/MatrixClientContext";
// import { REACTION_SHORTCODE_KEY } from "./ReactionsRow";
interface IProps {
    // The event we're displaying reactions for
    mxEvent: MatrixEvent;
    // The reaction content / key / emoji
    content: string;
    // A list of Matrix reaction events for this key
    reactionEvents: MatrixEvent[];
    // Whether to render custom image reactions
    customReactionImagesEnabled?: boolean;
}

export default class ReactionsRowButtonTooltip extends React.PureComponent<PropsWithChildren<IProps>> {
    public static contextType = MatrixClientContext;
    declare public context: React.ContextType<typeof MatrixClientContext>;

    public render(): React.ReactNode {
        const { content, reactionEvents, mxEvent, children } = this.props;

        const room = this.context.getRoom(mxEvent.getRoomId());
        if (room) {
            const senders: string[] = [];
            // let customReactionName: string | undefined;
            for (const reactionEvent of reactionEvents) {
                const member = room.getMember(reactionEvent.getSender()!);
                const name = member?.name ?? reactionEvent.getSender()!;
                senders.push(name);
                // customReactionName =
                //     (this.props.customReactionImagesEnabled &&
                //         REACTION_SHORTCODE_KEY.findIn(reactionEvent.getContent())) ||
                //     undefined;
            }
            // const shortName = unicodeToShortcode(content) || customReactionName;
            const shortName = content;
            const formattedSenders = formatList(senders, 2);
            // const caption = content ? _t("timeline.reactions.tooltip_caption", { shortName }) : undefined;
            const caption = reactionEvents.length === 1 ?
                _t("timeline.reactions.tooltip_caption.singular", { shortName }) :
                _t("timeline.reactions.tooltip_caption.plural", { shortName });

            return (
                <Tooltip description={formattedSenders} caption={caption} placement="right">
                    {children}
                </Tooltip>
            );
        }

        return children;
    }
}
